/**
 * @file
 * Behaviors for the Hero Banner.
 */
/* eslint-disable max-len */

(function(Drupal, $) {
  /**
   * Setup and attach the Hero Banner behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.sidebarMenu = {
    attach: function() {}
  };
})(Drupal, jQuery);
